export default __webpack_public_path__ + "static/media/profile.f315409b.jpg";